import Vue from 'vue'
import { VPopover } from 'v-tooltip'

Vue.component('VPopover', VPopover)
